import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Workflow } from './components/sections/Workflow';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { Audience } from './components/sections/Audience';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="3ikh8ubu2yx01">
      <MetaPixel data-id="element-1" data-mp="3ijpef4c7z5bc" />
      <Hero data-id="element-2" data-mp="3ii4ppvcl6gle" />
      <main data-id="element-3" data-mp="3mlaxx8j9ehui">
        <Problem data-id="element-4" data-mp="3ml17jjuay8oa" />
        <BeforeAfter data-id="element-5" data-mp="3mkhofzsx1e8o" />
        <Volumes data-id="element-6" data-mp="3mjq2lgp4euvl" />
        <Bonuses data-id="element-7" data-mp="3mj6hxs835sdv" />
        <Workflow data-id="element-8" data-mp="3rcj6k2crlz6m" />
        <Offer data-id="element-9" data-mp="3rbzomln47asl" />
        <Guarantee data-id="element-10" data-mp="3rdkisa5iorpx" />
        <Testimonials data-id="element-11" data-mp="3rd19tixuhdo1" />
        <Author data-id="element-12" data-mp="3relwkmdx3sbc" />
        <Audience data-id="element-13" data-mp="5opiv1o0k3w" />
        <Faq data-id="element-14" data-mp="682rygdekbl" />
        <FinalCta data-id="element-15" data-mp="4n6a3ahwrb3" />
      </main>
      <Footer data-id="element-16" data-mp="82ovg3doih9" />
      <PurchasePopup data-id="element-17" data-mp="2zl3brl12165b" />
      <FloatingCta data-id="element-18" data-mp="2zllijblcf2rh" />
    </div>;
}